/**
 * テーブルの操作ボタン
 * @param props
 * @returns
 */
import iconEdit from "../image/icon_edit1.svg";
import iconDelete from "../image/icon_delete1.svg";
import iconCommit from "../image/icon_commit1.svg";
import iconDownload from "../image/icon_download1.svg";

export const TableButton = ({ onClick }) => {
  return (
    <button onClick={onClick} style={{ backgroundColor: "rgba(0,0,0,0)" }}>
      ■
    </button>
  );
};
export default TableButton;

export const TableButtonEdit = ({ onClick }) => {
  return (
    <button onClick={onClick}>
      <img src={iconEdit} alt="変更" />
    </button>
  );
};

export const TableButtonDelete = ({ onClick }) => {
  return (
    <button onClick={onClick}>
      <img src={iconDelete} alt="削除" />
    </button>
  );
};

export const TableButtonCommit = ({ onClick }) => {
  return (
    <button onClick={onClick}>
      <img src={iconCommit} alt="確認" />
    </button>
  );
};

export const TableButtonDownload = ({ onClick }) => {
  return (
    <button onClick={onClick}>
      <img src={iconDownload} alt="ダウンロード" />
    </button>
  );
};
